import React from 'react';
import clsx from 'clsx';

export interface CountBubbleProps extends React.HTMLAttributes<HTMLSpanElement> {
    count: number;
    /** accent = qty in cart (28px) · danger = unread/pending (18px) · inverse = hidden options (22px) */
    tone?: 'accent' | 'danger' | 'inverse';
    max?: number;
}

const tones = {
    accent: 'min-w-[28px] h-7 px-1.5 text-[13px] bg-accent-500 text-ink-onAccent shadow-accent',
    danger: 'min-w-[18px] h-[18px] px-1 text-[10px] bg-status-danger text-white',
    inverse: 'min-w-[22px] h-[22px] px-1.5 text-xs bg-surface-inverse text-white',
};

export const CountBubble: React.FC<CountBubbleProps> = ({ count, tone = 'danger', max = 99, className, ...props }) => {
    if (count <= 0) return null;
    return (
        <span className={clsx('inline-flex items-center justify-center rounded-pill font-black leading-none tnum', tones[tone], className)} {...props}>
            {count > max ? `${max}+` : count}
        </span>
    );
};
export default CountBubble;
